import api from './fetch'

export function FETCH_LIST_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Goods(params).then(items => commit('SET_LIST', {
    items
  }))
}

export function FETCH_PRODUCT_INFO({
  commit,
  dispatch,
  state
}, {
  id
}) {
  return api.Product(id).then(items => commit('SET_PRODUCT_INFO', {
    items: items.data
  }))
}

export function FETCH_ASSESS_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Assess({ ...params, attr: '' }).then(items => commit('SET_ASSESS', {
    items: { ...items, attr: params.attr }
  }))
}

export function FETCH_BRANDS_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Brands(params).then(items => commit('SET_BRANDS', {
    items
  }))
}

export function FETCH_ZHIMA_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Zhima(params).then(items => commit('SET_ZHIMA', {
    items
  }))
}

export function FETCH_STATS_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Stats(params).then(items => commit('SET_STATS', {
    items
  }))
}

export function FETCH_REGION_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Region(params).then(items => commit('SET_REGION', {
    items
  }))
}

export function FETCH_ISCITY_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.isCity(params).then(items => commit('SET_ISCITY', {
    items
  }))
}

export function FETCH_USERS_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.User(params).then(items => commit('SET_USER', {
    items
  }))
}

export function FETCH_CREATE_ORDER({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Checkout(params).then(items => commit('SET_CREATE', {
    items
  }))
}

export function FETCH_ARTICLE_LIST({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Articles(params).then(items => commit('SET_ARTICLE_LIST', {
    items
  }))
}

export function FETCH_ORDER_LIST({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Orders(params).then(items => commit('SET_ORDER_LIST', {
    items
  }))
}

export function FETCH_ORDER_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Order(params).then(items => commit('SET_ORDER_DATA', {
    items
  }))
}

export function FETCH_CANCEL_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Cancel(params).then(items => commit('SET_CANCEL_DATA', {
    items
  }))
}

export function FETCH_EXPRESS_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Express(params).then(items => commit('SET_EXPRESS_DATA', {
    items
  }))
}

export function FETCH_TEST_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Test(params).then(items => commit('SET_TEST_DATA', {
    items
  }))
}

export function FETCH_COMMENT_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Comment(params).then(items => commit('SET_COMMENT_DATA', {
    items
  }))
}

export function FETCH_STATUS_DATA({
  commit,
  dispatch,
  state
}, {
  id
}) {
  return api.Status(id).then(items => commit('SET_STATUS_DATA', {
    items
  }))
}

export function FETCH_ARTICLE_DATA({
  commit,
  dispatch,
  state
}, {
  id
}) {
  return api.Article(id).then(items => commit('SET_ARTICLE_DATA', {
    items
  }))
}

export function FETCH_HOTWORD_DATA({
  commit,
  dispatch,
  state
}, {
  id
}) {
  return api.hotWord().then(items => commit('SET_HOTWORD_DATA', {
    items
  }))
}

export function FETCH_RECENT_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Recent(params).then(items => commit('SET_RECENT_DATA', {
    items
  }))
}

export function FETCH_CART_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Cart(params).then(items => commit('SET_CART_DATA', {
    items
  }))
}

export function FETCH_MAP_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Maps(params).then(items => commit('SET_MAP_DATA', {
    items
  }))
}

export function FETCH_USER_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Login(params).then(items => commit('SET_USER_DATA', {
    items
  }))
}

export function FETCH_BONUS_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Bonus(params).then(items => commit('SET_BONUS_DATA', {
    items
  }))
}

export function FETCH_BONUS_LIST({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.bonusList(params).then(items => commit('SET_BONUS_LIST', {
    items
  }))
}

export function FETCH_ATBONUS_DATA({
  commit,
  dispatch,
  state
}, params) {
  commit('SET_ATBONUS_DATA', params);
}

export function FETCH_TOKEN_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Token(params).then(items => commit('SET_TOKEN_DATA', {
    items
  }))
}

export function FETCH_WALLET_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Wallet(params).then(items => commit('SET_WALLET_DATA', {
    items
  }))
}

export function FETCH_WALLETS_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Wallets(params).then(items => commit('SET_WALLETS_DATA', {
    items
  }))
}

export function FETCH_WALLET_RELEASE({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.reWallet(params).then(items => commit('SET_WALLET_RELEASE', {
    items
  }))
}

export function FETCH_ACCOUNT_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Account(params).then(items => commit('SET_ACCOUNT_DATA', {
    items
  }))
}

export function FETCH_SMS_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Sms(params).then(items => commit('SET_SMS_DATA', {
    items
  }))
}

export function FETCH_INVITE_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Invite(params).then(items => commit('SET_INVITE_DATA', {
    items
  }))
}

export function FETCH_OLDNEW_LIST({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Oldnews(params).then(items => commit('SET_OLDNEW_LIST', {
    items
  }))
}
export function FETCH_OLDNEW_DATA({
  commit,
  dispatch,
  state
}, {
  params
}) {
  return api.Oldnew(params).then(items => commit('SET_OLDNEW_DATA', {
    items
  }))
}


// WEBPACK FOOTER //
// ./src/store/actions.js